<template>
  <div class="container">
    <nav class="nav">
      <Logo />
      <router-link to="/add" class="tf-button tf-button--narrow">
        Add/Change summoner
      </router-link>
    </nav>

    <Intro />
    <SummonerList />
  </div>
</template>

<script>
import SummonerList from '@/components/SummonerList.vue'
import Logo from '@/components/Logo.vue'
import Intro from '@/components/Intro.vue'

export default {
  name: 'App',

  components: {
    SummonerList,
    Logo,
    Intro
  }
}
</script>

<style scoped lang="scss">
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.beta-note {
  color: #004085;
  background-color: #cce5ff;
  border-color: #b8daff;
  padding: .75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: .25rem;
  margin: 0 0 20px;

  a {
    font-weight: bold;
    border-bottom: 1px dashed currentColor;
  }
}

.country-rankings {
  border-radius: 3px;
  border: 1px dashed var(--text-color);
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  font-family: var(--head-font);

  @media (max-width: 500px) {
    flex-direction: column;

    span {
      margin-bottom: 15px;
    }
  }
}
</style>